import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
// material
import { styled } from '@mui/material/styles';
import { Box, Link, Button, Drawer, Typography, Avatar, Chip } from '@mui/material';
import secureLocalStorage from 'react-secure-storage';
import { useTranslation } from 'react-i18next';
// components
import Logo from '../../components/Logo';
import Scrollbar from '../../components/Scrollbar';
import NavSection from '../../components/NavSection';
import { MHidden } from '../../components/@material-extend';
//
import DataSidbar from './SidebarConfig';
import account from '../../_mocks_/account';
import './style.css';
// ----------------------------------------------------------------------

const DRAWER_WIDTH = 300;

const RootStyle = styled('div')(({ theme }) => ({
  backgroundColor: 'transparent',
  [theme.breakpoints.up('lg')]: {
    flexShrink: 0,
    width: DRAWER_WIDTH,
    left: 'auto !important'
  }
}));

const AccountStyle = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  padding: theme.spacing(2, 2.5),
  borderRadius: theme.shape.borderRadiusSm,
  backgroundColor: 'transparent'
}));

// ----------------------------------------------------------------------

DashboardSidebar.propTypes = {
  isOpenSidebar: PropTypes.bool,
  onCloseSidebar: PropTypes.func
};

export default function DashboardSidebar({ isOpenSidebar, onCloseSidebar }) {
  const [t, i18n] = useTranslation();
  const { pathname } = useLocation();
  const [uu, setUu] = useState(DataSidbar());
  console.log('data ***>', uu);
  const API_ENDPOINT = process.env.REACT_APP_BASE_URL;
  const userDetails = JSON.parse(localStorage.getItem('user'));
  const pic = `${API_ENDPOINT}${userDetails.photo}`;

  useEffect(() => {
    if (isOpenSidebar) {
      onCloseSidebar();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  const renderContent = (
    <Scrollbar
      style={{
        backgroundColor: '#ffffff',
        paddingTop: '50px',
        paddingBottom: '50px',
        height: '100%',
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      <Box sx={{ mb: 2, mx: 2.5 }}>
        <AccountStyle>
          <Avatar src={pic} alt="photoURL" style={{ height: 200, width: 200 }} />
          <Box style={{ marginTop: 20 }}>
            <Typography variant="subtitle2" align="center" sx={{ color: 'text.primary' }}>
              {userDetails.username}
            </Typography>
          </Box>
          <Box
            style={{ marginTop: 15, padding: '0px 10px', display: 'flex', alignItems: 'center' }}
          >
            <Typography
              style={{ textTransform: 'capitalize', margin: '0px 5px' }}
              variant="subtitle2"
              sx={{ color: 'text.primary' }}
            >
              {t('votrecode')}:
            </Typography>
            <Chip
              label={userDetails.creche_code}
              style={{ backgroundColor: '#ec8181', color: 'white' }}
            />
          </Box>
        </AccountStyle>
      </Box>
      <NavSection navConfig={DataSidbar()} />
    </Scrollbar>
  );

  return (
    <RootStyle style={{ left: 'auto' }}>
      <MHidden width="lgUp">
        <Drawer
          open={isOpenSidebar}
          onClose={onCloseSidebar}
          anchor="right"
          PaperProps={{
            sx: { width: DRAWER_WIDTH }
          }}
        >
          {renderContent}
        </Drawer>
      </MHidden>

      <MHidden width="lgDown">
        <Drawer
          open
          variant="persistent"
          anchor={document.body.dir === 'ltr' ? 'left' : 'right'}
          PaperProps={{
            sx: {
              width: DRAWER_WIDTH,
              bgcolor: 'background.default'
            },
            style: {
              left: document.body.dir === 'ltr' ? 0 : 'unset !important',
              right: document.body.dir === 'rtl' ? 0 : 'unset !important'
            }
          }}
        >
          {renderContent}
        </Drawer>
      </MHidden>
    </RootStyle>
  );
}
